import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("br_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // Inject the active data-origin (seed|live) into every GET so seed and live never mix.
  if ((cfg.method || "get").toLowerCase() === "get") {
    cfg.params = { origin: localStorage.getItem("br_origin") || "seed", ...(cfg.params || {}) };
  }
  return cfg;
});

export function getOrigin() {
  return localStorage.getItem("br_origin") || "live";
}
export function setOrigin(o) {
  localStorage.setItem("br_origin", o);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
